import "bootstrap-icons/font/bootstrap-icons.css";
import { useState } from "react";

import "./user.css";

import { Button, Segmented, Select, Table, Tooltip } from "antd";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Search from "antd/es/transfer/search";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import { loadAllEmploymentStatus } from "../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { getAllWorkPlace } from "../../redux/rtk/features/masters/workPlaceSlice";
import { getDepartments } from "../department/departmentApis";
import { getRoles } from "../role/roleApis";

import { ActiveUser, deleteStaff, deleteStaffPermanent, loadAllStaff, sendWelcomeEmail } from "../../redux/rtk/features/user/userSlice";
import ViewBtn from "../Buttons/ViewBtn";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import UserDataExport from "./userExportData";
import getSetting from "../../api/getSettings";

function CustomTable({ list }) {
	const dispatch = useDispatch();
	const [status, setStatus] = useState("true");
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [selectedWorkplace, setSelectedWorkplace] = useState(null);
	const [selectedRole, setSelectedRole] = useState(null);
	const [roleData, setRoleData] = useState(null);

	const [selectedDepartment, setSelectedDepartment] = useState(null);
	const [departmentData, setDepartmentData] = useState(null);

	const [selectedDesignation, setSelectedDesignation] = useState(null);
	const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState(null);

	const [companyNames, setCompanyNames] = useState([]);
	const [selectedCompanyName, setSelectedCompanyName] = useState(null);
	const workPlace = useSelector((state) => state.workPlace?.list);
	const designation = useSelector((state) => state.designations?.list);
	const employmentStatus = useSelector((state) => state.employmentStatus?.list);
	const [isFiltersVisible, setIsFiltersVisible] = useState(false);

	console.log("workPlace", workPlace);

	const { loading } = useSelector((state) => state.users);

	useEffect(() => {
		dispatch(getAllWorkPlace())
		dispatch(loadAllDesignation())
		dispatch(loadAllEmploymentStatus())
	}, [])

	useEffect(() => {
		getRoles()
			.then((d) => setRoleData(d))
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		getDepartments()
			.then((d) => setDepartmentData(d))
			.catch((error) => console.log(error));
	}, []);
	const toggleFilters = () => {
		setIsFiltersVisible((prev) => !prev);
	};

	useEffect(() => {
        const fetchCompanyNames = async () => {
            try {
                const response = await getSetting();
                console.log("API Response:", response);

                if (response && Array.isArray(response.result)) {
                    setCompanyNames(response.result);
                } else {
                    console.error("API response is not an array:", response);
                    setCompanyNames([]);
                }
            } catch (error) {
                console.error("Error fetching company names:", error);
                setCompanyNames([]);
            }
        };

        fetchCompanyNames();
    }, []);
	const handleCompanyNameChange = (value) => {
        setSelectedCompanyName(value);
    };
	const columns = [
		{
			id: 1,
			title: "ID",
			dataIndex: "serial",
			key: "serial"
		},
		{
			id: 2,
			title: "Name",

			key: "fullName",
			render: ({ firstName, lastName }) =>
				(firstName + " " + lastName).toUpperCase(),
		},
		{
			id: 3,
			title: "Usr Name",
			dataIndex: "userName",
			key: "userName",
		},

		{
			id: 4,
			title: "Employee Id",
			dataIndex: "employeeId",
			key: "employeeId",

		},
		{
			id: 8,
			title: "Company NAme",
			dataIndex: "companyMaster",
			key: "companyMaster",
			render: (record) => (record?.company_name ? record?.company_name : "N/A"),
		},
		{
			id: 4,
			title: "Workplace",
			dataIndex: "workPlaceHistory",
			key: "workPlaceHistory",
			render: (record) => {
				if (!record || !Array.isArray(record) || record.length === 0) {
					return "N/A";
				}
				const workplace = record[0]?.workplace;
				return workplace?.workplace || "N/A";
			}
		},
		{
			id: 5,
			title: "Designation",
			dataIndex: "designationHistory",
			key: "designationHistory",
			render: (record) =>
				record.length > 0 ? record[0].designation.name : "N/A",
		},

		// TODO: fix this column to show the correct data

		{
			id: 6,
			title: "E-Status",
			dataIndex: "employmentStatus",
			key: "employmentStatus",
			render: (record) => (record?.name ? record?.name : "N/A"),
		},
		{
			id: 8,
			title: "Department",
			dataIndex: "department",
			key: "department",
			render: (record) => (record?.name ? record?.name : "N/A"),
		},

		{
			id: 9,
			title: "Shift",
			dataIndex: "shift",
			key: "shift",
			render: (record) => (record?.name ? record?.name : "N/A"),
		},

		{
			id: 7,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id, record) => (
				<div className='flex justify-start space-x-1'>
					<UserPrivateComponent permission={"readSingle-user"}>
						<ViewBtn path={`/admin/hr/staffs/${id}/`} />
					</UserPrivateComponent>
					{/* <UserPrivateComponent permission={"readSingle-attendance"}>
						<AttendBtn path={`/admin/attendance/user/${id}`} />
					</UserPrivateComponent> */}
					{/* <UserPrivateComponent permission={"delete-user"}>
						<Tooltip title='Disable User'>
							<button
								className='bg-orange-600 hover:bg-red-700 text-white font-bold px-2 rounded'
								onClick={() => handleDelete(id)}
							>
								<i className="bi bi-person-x-fill"></i>
							</button>
						</Tooltip>
					</UserPrivateComponent> */}
					{record.status === 0 ? (
					<UserPrivateComponent permission={"delete-user"}>
						<Tooltip title='Reinstate User'>
							<button
								className='bg-green-600 hover:bg-green-700 text-white font-bold px-2 rounded'
								onClick={() => handleActiveUser(id)}
							>
								<i className="bi-person-check-fill"></i>
							</button>
						</Tooltip>
					</UserPrivateComponent>
					):null}
					<UserPrivateComponent permission={"delete-user"}>
						<Tooltip title='Delete User'>
							<button
								className='bg-red-600 hover:bg-red-700 text-white font-bold px-2 rounded'
								onClick={() => handlePermanentDelete(id)}
							>
								<i className="bi bi-person-dash-fill"></i>
							</button>
						</Tooltip>
					</UserPrivateComponent>
					<UserPrivateComponent permission={"delete-user"}>
						<Tooltip title="Send Welcome Email">
							<button
								className="bg-blue-500 hover:bg-blue-600 text-white font-bold px-2 rounded"
								onClick={() => handleSendWelcomeEmail(record)}
							>
								<i className="bi bi-envelope-fill"></i>
							</button>
						</Tooltip>
					</UserPrivateComponent>
				</div>
			),
		},
	];
	//make a onChange function
	const onChange = (value) => {
		setStatus(value);
		dispatch(loadAllStaff({ status: value }));
	};

	const handleDelete = async (userId) => {
		const confirmAction = window.confirm(
			"Are you sure you want to disable this user?"
		);
		if (confirmAction) {
			// Dispatch an action to update the user's status
			await dispatch(deleteStaff(userId)).unwrap();
			dispatch(loadAllStaff({ status: "true" }));

		}
	};

	const handleActiveUser = async (userId) => {
		const confirmAction = window.confirm(
			"Are you sure you want to reinstate this user?"
		);
		if (confirmAction) {
			// Dispatch an action to update the user's status
			await dispatch(ActiveUser(userId)).unwrap();
			dispatch(loadAllStaff({ status: "true" }));

		}
	};
	const handlePermanentDelete = async (userId) => {
		const confirmAction = window.confirm(
			"Are you sure you want to delete this user?"
		);
		if (confirmAction) {
			// Dispatch an action to update the user's status
			await dispatch(deleteStaffPermanent(userId)).unwrap();
			dispatch(loadAllStaff({ status: "true" }));

		}
	};

	const handleSendWelcomeEmail = async (user) => {
		try {
			const confirmAction = window.confirm(
				`Send a welcome email to ${user.firstName} ${user.lastName}?`
			);
			if (confirmAction) {
				console.log("userId", user.id);

				// Replace with your API call to send the email
				await dispatch(sendWelcomeEmail(user.id)).unwrap();
				alert(`Welcome email sent to ${user.firstName} (${user.userName})`);
			}
		} catch (error) {
			console.error("Error sending welcome email:", error);
			alert("Failed to send welcome email. Please try again.");
		}
	};


	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const handleWorkplaceChange = (value) => {
		setSelectedWorkplace(value);
	};

	const handleRoleChange = (value) => {
		setSelectedRole(value);
	};

	const handleDepartmentChange = (value) => {
		setSelectedDepartment(value);
	};

	const handleDesignationChange = (value) => {
		setSelectedDesignation(value);
	};

	const handleEmploymentStatusChange = (value) => {
		setSelectedEmploymentStatus(value);
	};
	const resetFilters = () => {
		setSearchTerm("");
		setSelectedWorkplace(null);
		setSelectedRole(null);
		setSelectedDepartment(null);
		setSelectedDesignation(null);
		setSelectedEmploymentStatus(null);
		setSelectedCompanyName(null);
		// Dispatch action to reload all staff data
		dispatch(loadAllStaff({ status: "true" }));
	};

	const toggleFiltersVisibility = () => {
		setIsFiltersVisible((prev) => {
			if (prev) {
				// Reset filters when hiding them
				resetFilters();
			}
			return !prev;
		});
	};
	const handleSearchChange = (e) => {
		setSearchTerm(e.target.value);
	};


	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

	const filteredList = list?.filter((item) => {
		const searchMatch =
			(item.userName && item.userName.toLowerCase().includes(searchTerm.toLowerCase())) ||
			(item.firstName && item.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
			(item.lastName && item.lastName.toLowerCase().includes(searchTerm.toLowerCase())) ||
			(item.employeeId && item.employeeId.toLowerCase().includes(searchTerm.toLowerCase()));


		const workplaceMatch =
			!selectedWorkplace ||
			(item.workPlaceHistory &&
				Array.isArray(item.workPlaceHistory) &&
				item.workPlaceHistory.length > 0 &&
				item.workPlaceHistory[0]?.workplace?.id === selectedWorkplace);

		console.log("item", item);

		const roleMatch =

			!selectedRole || (item.role && item.role.id === selectedRole);

		const departmentMatch =
			!selectedDepartment ||
			(item.department && item.department.id === selectedDepartment);

		const designationMatch =
			!selectedDesignation ||
			(item.designationHistory &&
				Array.isArray(item.designationHistory) &&
				item.designationHistory.length > 0 &&
				item.designationHistory[0]?.designation?.id === selectedDesignation);

		const employmentStatusMatch =
			!selectedEmploymentStatus ||
			(item.employmentStatus && item.employmentStatus.id === selectedEmploymentStatus);

			const companyNameMatch =
            !selectedCompanyName ||
            (item.companyMaster && item.companyMaster.company_name === selectedCompanyName);
		return (
			searchMatch &&
			workplaceMatch &&
			roleMatch &&
			departmentMatch &&
			designationMatch &&
			employmentStatusMatch &&
            companyNameMatch
		);
	});

	return (
		<>
			{/* <div className="w-full" style={{ padding: "0 20px" }}> */}
			<div className="w-full">

				<div className='ant-card p-4 rounded mt-2 w-full' style={{ maxWidth: "1200px", margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
					<div className='flex my-2 justify-between'>
						<div className='w-50'>
							<h4 className='text-2xl mb-2'>Employee List</h4>
						</div>
						{list && (
							<div className='flex justify-end mr-4'>
								<div className='flex items-center'>

									<div style={{ width: 150, marginLeft: "10px" }}>
										<UserDataExport userData={list} />
									</div>
								</div>
								<div>
									<Segmented
										className='text-center rounded text-blue-500'
										size='middle'
										options={[
											{
												label: (
													<span>
														<i className='bi bi-person-lines-fill'></i> Active
													</span>
												),
												value: "true",
											},
											{
												label: (
													<span>
														<i className='bi bi-person-dash-fill'></i> Inactive
													</span>
												),
												value: "false",
											},
										]}
										value={status}
										onChange={onChange}
									/>
								</div>
							</div>
						)}

					</div>
					{list && (
						<div style={{ marginBottom: "30px" }}>
							<div className="flex justify-between items-center" style={{ gap: "20px" }}>
								{/* Column Selection Dropdown */}
								<ColVisibilityDropdown
									options={columns}
									columns={columns}
									columnsToShowHandler={columnsToShowHandler}
								/>

								<Button type="primary" onClick={toggleFiltersVisibility}>
									{isFiltersVisible ? "Hide Filters" : "Show Filters"}
								</Button>
								{isFiltersVisible && (
									<div>
										<Select
                                            placeholder="Filter by Company"
                                            onChange={handleCompanyNameChange}
                                            allowClear
                                            style={{ width: 150, marginRight: "10px" }}
                                        >
                                            <Select.Option value={null}>All</Select.Option>
                                            {companyNames.map((company) => (
                                                <Select.Option 
                                                    key={company.id} 
                                                    value={company.company_name}
                                                >
                                                    {company.company_name}
                                                </Select.Option>
                                            ))}
                                        </Select>
										<Select
											placeholder="Filter by Workplace"
											onChange={handleWorkplaceChange}
											allowClear
											style={{ width: 150, marginRight: "10px" }}
										>
											<Select.Option value={null}>All</Select.Option> {/* Add this line for "All" option */}
											{workPlace?.map((wp) => (
												<Select.Option key={wp.id} value={wp.id}>
													{wp.workplace}
												</Select.Option>
											))}
										</Select>

										<Select
											placeholder="Select Role"
											style={{ width: 150, marginRight: "10px" }}
											onChange={handleRoleChange}
											allowClear
										>
											{roleData?.map((role) => (
												<Select.Option key={role.id} value={role.id}>
													{role.name}
												</Select.Option>
											))}
										</Select>



										<Select
											placeholder="Select Department"
											style={{ width: 150, marginRight: "10px" }}
											onChange={handleDepartmentChange}
											allowClear
										>
											{departmentData?.map((department) => (
												<Select.Option key={department.id} value={department.id}>
													{department.name}
												</Select.Option>
											))}
										</Select>

										<Select
											placeholder="Select Designation"
											style={{ width: 150, marginRight: "10px" }}
											onChange={handleDesignationChange}
											allowClear
										>
											{designation?.map((designation) => (
												<Select.Option key={designation.id} value={designation.id}>
													{designation.name}
												</Select.Option>
											))}
										</Select>

										<Select
											placeholder="Select Employment Status"
											style={{ width: 150, marginRight: "10px" }}
											onChange={handleEmploymentStatusChange}
											allowClear
										>
											{employmentStatus?.map((status) => (
												<Select.Option key={status.id} value={status.id}>
													{status.name}
												</Select.Option>
											))}
										</Select>
									</div>
								)}

								{/* Search Component */}
								<Search
									placeholder="Search by username and Employee Id"
									onChange={(e) => setSearchTerm(e.target.value)}
									allowClear
									style={{
										width: 300,
										marginRight: "10px",
										maxWidth: "100%",
									}}
								/>
							</div>
						</div>
					)}


					<Table
						scroll={{ x: true }}
						loading={loading}
						pagination={{
							defaultPageSize: 20,
						}}
						columns={columnsToShow}
						// dataSource={list ? addKeys(list) : []}
						dataSource={filteredList ? addKeys(filteredList) : []}

					/>
				</div>
			</div>
		</>
	);
}

const GetAllCust = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.users.list);


	useEffect(() => {
		dispatch(loadAllStaff({ status: "true" }));
	}, [dispatch]);

	// useEffect(() => {
	//   deleteHandler(list, deletedId);
	// }, [deletedId, list]);

	return (
		<UserPrivateComponent permission={"readAll-user"}>
			<PageTitle title='Back' />

			<div className='card card-custom w-full' style={{ maxWidth: "1200px", margin: "0 auto" }}>
				<div className='card-body'>
					<CustomTable list={list} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default GetAllCust;
